import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Notification from '../Header/Notification';

const StyledNewImportant = styled.div`
  /* retocar modulo cuando haya que ponerse con esta tarea */
  ${mediaqueries.lessThan('mobile')`
    margin-bottom: ${rem('25px')};
  `}
  ${mediaqueries.greaterThan('desktop')`
    grid-column: 1 / 3;
    grid-row: 1;
    -ms-grid-row: 1;
    -ms-grid-column-span: 3;
    margin-top: ${rem('15px')};
  `};
  padding: 0;
  background-color: ${props => props.theme.colors.light};
  grid-column: 1 / 3;
  grid-row: 2;
  -ms-grid-column: 1 / 3;
  -ms-grid-row: 2;
  margin-top: 0;
`;

const StyledColumnLeft = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    grid-column: 1;
    grid-row: 3;
    -ms-grid-row: 3;
    -ms-grid-column: 1;
    -ms-grid-column-span: 1;
    margin-right: ${rem('7px')};
    max-height: ${rem('346px')};
  `};
  max-height: ${rem('346px')};
  grid-column: 1 / 3;
  grid-row: 3;
  -ms-grid-row: 3;
  -ms-grid-column: 1;
  -ms-grid-column-span: 2;
  margin-right: 0;
`;

const StyledColumn = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    grid-column: 2;
    grid-row: 3;
    -ms-grid-row: 3;
    -ms-grid-column: 2;
    -ms-grid-column-span: 2;
    margin-left: ${rem('7px')};
    display:block;
  `};
  grid-column: 1 / 3;
  grid-row: 3;
  -ms-grid-row: 3;
  -ms-grid-column: 1;
  -ms-grid-column-span: 2;
  display: none;
  margin-left: 0;
`;

const StyledBoxFixed = styled.div`
  /* capa y props pendiente de si es o no válida para columna fija */
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('652px')};
  `}
  ${props =>
    props.fixed &&
    ` position:fixed;
      top:0;
  `};
`;

const StyledTabs = styled.ul`
  ${mediaqueries.greaterThan('desktop')`
    grid-column: 1 / 3;
    grid-row: 2;
    -ms-grid-row: 2;
    -ms-grid-column-span: 3;
    margin: ${rem('15px')} 0;
    background-color:transparent;
  `};
  padding: 0;
  margin-top: ${rem('0px')};
  display: flex;
  grid-column: 1 / 3;
  grid-row: 1;
  -ms-grid-column: 1 / 3;
  -ms-grid-row: 1;
  top: 0;
  background-color: ${props => props.theme.colors.light};
  margin-bottom: 0;
  z-index: 25;
  top: ${rem('73px')};
  ${mediaqueries.lessThan('mobile')`
    top:${rem('48px')};
  `};
`;

const StyledTabsChildren = styled.li`
  display: flex;
  position: relative;
  width: 50%;
  align-items: center;
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.bold};
  background-color: transparent;
  // border-left: ${rem('2px')} solid ${props => props.theme.colors.dark};
  // border-top: ${rem('2px')} solid ${props => props.theme.colors.dark};
  justify-content: center;
  padding-left: 0;
  cursor: pointer;
  height: ${rem('58px')};
  font-size: ${rem('32px')};

  &:before {
    content: none;
  }

  &:first-child {
    margin-right: ${rem('5px')};
    &:after {
      right: -${rem('8px')};
    }
  }
  ${props =>
    props.active &&
    `background-color:${props.theme.colors.light};
      color:${props.theme.colors.dark};
  `};
  &:first-child {
    // border-right: ${rem('2px')} solid ${props => props.theme.colors.dark};
    ${mediaqueries.lessThan('desktop')`
      border-right: 0.1px solid;
      border-right-style: ridge;
    `};
    border-left: 0;
    margin-bottom: 10px;
    &:after {
      width: ${rem('6px')};
      height: ${rem('2px')};
      background-color: transparent;
      position: absolute;
      content: '';
      bottom: 0;
    }
  }

  ${mediaqueries.lessThan('mobile')`
    height: ${rem('45px')};
    font-size: ${props => props.theme.fontSize.xlarge};
    margin: 15px 0px 15px 10px;
    padding: 10px 5px 10px 10px;
    &:first-child {
      margin-right: ${rem('2px')};
      margin: 15px 0px 15px 10px;
      padding: 10px 5px 10px 10px;
      &:after {
        right: -${rem('6px')};
      }
    }
  `};
  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.active &&
      `  background-color: transparent;
      color: ${props.theme.colors.dark};
    `};
    cursor:default;
    height: ${rem('60px')};
    font-size: ${rem('34px')};
    justify-content: flex-start;
    padding-left: ${rem('30px')};
    color:${props => props.theme.colors.dark};
    &:first-child {
      margin-right: ${rem('14px')};
      background-color: transparent;
      color:${props => props.theme.colors.dark};
      &:after {
        display:none;
      }
    }
    &:last-child {
      margin-right: ${rem('14px')};
      background-color: transparent;
      color:${props => props.theme.colors.dark};
      &:after {
        display:none;
      }
    }
  `};
`;

const StyledBoxMain = styled.section`
  background-color: ${props => props.theme.colors.grayLighter};
  position: relative;
  z-index: 2;
  ${mediaqueries.lessThan('1280px')`
    ${StyledColumn} {
      ${props => (props.tabs === 2 ? `display: block` : `display:none`)};
    }
    ${StyledNewImportant} {
      ${props => (props.tabs === 2 ? `display: none` : `display:block`)};
    }
    ${StyledColumnLeft} {
      ${props => (props.tabs === 2 ? `display: none` : `display:block`)};
    }
  `};
  ${mediaqueries.greaterThan('desktop')`
    ${StyledColumn}, ${StyledNewImportant}, ${StyledColumnLeft} {
      ${props => (props.tabs === 2 ? `display: block` : `display: block`)};
    }
  `};
  &.boxWidget {
    background-color: transparent;
  }
`;

const StyledBoxInside = styled.div`
  display: grid;
  display: -ms-grid;
  grid-template-columns: 50% 50%;
  -ms-grid-columns: 50% 50%;
  padding: 0;
  margin: auto;
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('1232px')};
  `};
`;

// Capa para los mini Widgets
const StyledMiniWidgetWrap = styled.div`
  background-color: ${props => props.theme.colors.light};
  margin: 0 0 0.9375rem 0;
  display: flex;
  justify-content: space-between;
  padding: ${rem('7px')};
  ${mediaqueries.greaterThan('mobile')`
   padding: ${rem('15px')};
  `};
`;

const StyledNotification = styled(Notification)`
  display: none;
`;

export {
  StyledNewImportant,
  StyledBoxMain,
  StyledTabs,
  StyledTabsChildren,
  StyledColumnLeft,
  StyledColumn,
  StyledBoxInside,
  StyledBoxFixed,
  StyledMiniWidgetWrap,
  StyledNotification
};
